<main>
  <loading-overlay [isLoading]="isLoading > 0"></loading-overlay>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'Merge_Lot_Items_Title' | translateWF: 'Merge Lot Items' }}</h1>
        <div class="page__title_buttons">
          @if (canEdit()) {
            <p-button [label]="'Common_Add' | translateWF: 'Add'" icon="pi pi-plus" (click)="redirectToDetail()" />
          }
        </div>
      </div>
    </div>

    <section>
      <div class="grid grid-cols-12 gap-[2rem]">
        <!-- Filters -->
        <div class="col-span-12 md:col-span-3 xl:col-span-3">
          <form [formGroup]="filtersForm" (ngSubmit)="loadTableData()">
            <p-card>
              <ng-template #header>
                <div class="flex items-center gap-2">
                  <span>{{ 'Common_Filters' | translateWF: 'Filters' }}</span>
                </div>
              </ng-template>

              <div class="form-box">
                <label>{{ 'Merge_Lot_Items_Receiving_Lot_Item' | translateWF: 'Receiving Lot Item' }}</label>
                <input pInputText type="text" class="w-full" formControlName="lotItemNumber" />
              </div>

              <ng-template pTemplate="footer">
                <div class="flex gap-4 mt-6">
                  <p-button [label]="'Common_Reset' | translateWF: 'Reset'" variant="outlined" class="w-full" [styleClass]="'w-full'" (click)="resetFilters()" />
                  <p-button [label]="'Common_Apply' | translateWF: 'Apply'" class="w-full" [styleClass]="'w-full'" (click)="loadTableData()" />
                </div>
              </ng-template>
            </p-card>
          </form>
        </div>

        <!-- Table -->
        <div class="col-span-12 md:col-span-9 xl:col-span-9">
          @if (dataSource.length > 0) {
            <p-table [value]="dataSource" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 25, 50]" selectionMode="single">
              <ng-template #header>
                <tr>
                  <th>{{ 'Merge_Lot_Items_Receiving_Lot_Item' | translateWF: 'Receiving Lot Item' }}</th>
                  <th>{{ 'Common_Item_Code' | translateWF: 'Item Code' }}</th>
                  <th>{{ 'Merge_Lot_Items_Merges' | translateWF: 'Merges' }}</th>
                  <th>{{ 'Merge_Lot_Items_Merged_Quantity' | translateWF: 'Merged Quantity' }}</th>
                  <th>{{ 'Merge_Lot_Items_Current_Net_Quantity' | translateWF: 'Current Net Quantity' }}</th>
                  <th>{{ 'Merge_Lot_Items_Last_Merge' | translateWF: 'Last Merge' }}</th>
                  <th></th>
                </tr>
              </ng-template>
              <ng-template #body let-item>
                <tr class="cursor-pointer" (click)="redirectToDetail(item.id)">
                  <td>
                    <a>{{ item.number }}</a>
                  </td>
                  <td>{{ item.itemCode }}</td>
                  <td>{{ mergeCount(item) }}</td>
                  <td>{{ mergedQuantity(item) | number: '1.2-2' }}</td>
                  <td>{{ item.netQuantity | number: '1.2-2' }}</td>
                  <td>{{ lastMergeDate(item) | date: 'short' }}</td>
                  <td class="!text-end">
                    <p-button icon="pi pi-eye" variant="text" (onClick)="redirectToDetail(item.id)" />
                  </td>
                </tr>
              </ng-template>
            </p-table>
          } @else {
            <p-message class="flex space-between max-w-[360px]" severity="secondary"
              >{{ 'Merge_Lot_Items_No_Merges_Found' | translateWF: 'No merged lot items found' }}
              @if (canEdit()) {
                <p-button class="ml-2" [label]="'Common_Add' | translateWF: 'Add'" (click)="redirectToDetail()" />
              }
            </p-message>
          }
        </div>
      </div>
    </section>
  </div>
</main>

<p-toast position="top-center" />
